import { QuantifyCategoriesToggle } from '@modules/quantify/components/QuantifyCategoriesToggle';

import {
  CompareBarChart,
  CompareBarChartProps,
} from '@modules/quantify/components/QuantifyChart/CompareBarChartWrapper/CompareBarChart';
import { QuantifyOrCompareChartTitle } from '@modules/quantify/components/QuantifyChart/QuantifyOrCompareChartTitle';
import { QuantifyReportStatusWidget } from '@modules/quantify/components/QuantifyReportStatusWidget';
import {
  useGetChartLabelOptions,
  useGetCompareChartData,
} from '@modules/quantify/hooks';
import { Stack } from '@mui/material';

interface CompareBarChartWrapperProps
  extends Omit<CompareBarChartProps, 'data'> {
  shouldShowToggleGroup?: boolean;
  shouldShowTitle?: boolean;
}

export const CompareBarChartWrapper = ({
  shouldShowToggleGroup = true,
  shouldShowTitle: shouldShowTitleDefault = true,
  ...props
}: CompareBarChartWrapperProps) => {
  const data = useGetCompareChartData();

  const getLabelOptions = useGetChartLabelOptions({
    data,
  });

  const isDataEmpty = !data.length;
  const shouldShowTitle = shouldShowTitleDefault && !isDataEmpty;

  return (
    <Stack height="100%">
      <Stack
        direction="row"
        justifyContent={shouldShowTitle ? 'space-between' : 'flex-end'}
        alignItems="center"
        my={!shouldShowTitle && !shouldShowToggleGroup ? 0 : 2}
      >
        {shouldShowTitle && (
          <QuantifyOrCompareChartTitle
            data={data}
            pl={3}
            getLabelOptions={getLabelOptions}
          />
        )}
        {shouldShowToggleGroup && (
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            spacing={3}
          >
            <QuantifyCategoriesToggle />
          </Stack>
        )}
      </Stack>
      {!isDataEmpty ? (
        <CompareBarChart data={data} {...props} />
      ) : (
        <QuantifyReportStatusWidget />
      )}
    </Stack>
  );
};
